import type { AnnotationStroke, AnnotationData } from '../../../../lib/inspections';

export type { AnnotationStroke, AnnotationData };

export interface Photo {
  id: string;
  url: string;
  thumbnailUrl?: string;
  caption?: string;
}

export interface AnnotationConfig {
  companyId: string;
  inspectionId: string;
  /** 읽기 전용 모드 (기본: false) */
  readonly?: boolean;
  /** 그리기 메모 표시 초기값 (기본: true) */
  initialShowAnnotation?: boolean;
  /** 어노테이션 조회 건너뛰기 (resolution 사진 등 점검 사진이 아닌 경우) */
  skipAnnotation?: boolean;
  /** 비점검 컨텍스트용 커스텀 API 어댑터 (전달 시 inspection API 대신 사용) */
  customApi?: {
    cacheKey: string;
    get: (photoId: string) => Promise<{ data: { version: number; strokes: any[] } } | null>;
    save: (photoId: string, data: AnnotationData) => Promise<any>;
  };
}

export interface PhotoViewerProps {
  photos: Photo[];
  currentIndex: number;
  isOpen: boolean;
  onClose: () => void;
  onIndexChange?: (index: number) => void;
  onDelete?: (photoId: string) => void;
  onDownload?: (photoId: string) => void;
  /** 전달 시 그리기 기능 활성화 */
  annotation?: AnnotationConfig;
}

// 기본 색상 팔레트
export const COLOR_PALETTE = [
  { name: '빨강', value: '#ef4444' },
  { name: '파랑', value: '#3b82f6' },
  { name: '노랑', value: '#eab308' },
  { name: '초록', value: '#22c55e' },
  { name: '검정', value: '#171717' },
];

// 굵기 프리셋
export const STROKE_WIDTHS = [2, 4, 6, 8, 12];

export type ActiveTool = 'draw' | 'pan' | 'eraser';
